/*
 * Routes-general.ts
 * Description: Includes the declaration of the
 * general routes for Vue Router
 */

// Importing Components
import PageWelcome from '@/pages/PageWelcome.vue';
import PageHelp from '@/pages/PageHelp.vue';
import PageForUs from '@/pages/PageForUs.vue';
import PageOurMission from '@/pages/PageOurMission.vue';

const routesGeneral = [
    // Defining the root url of the application.
    {
        path: '/',
        name: 'welcome',
        component: PageWelcome,
    },
    // Defining the help page route.
    {
        path: '/help',
        name: 'help',
        component: PageHelp,
    },
];
export default routesGeneral;
